export default "__VITE_ASSET__92feb81b__"